<template>
  <div id="app">
    <!-- <environment-switcher v-if="showEnvironmentSwitcher" /> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import EnvironmentSwitcher from './components/EnvironmentSwitcher.vue';

export default {
  name: 'App',
  components: {
    // EnvironmentSwitcher
  },
  computed: {
    // 只在开发环境显示环境切换器，生产环境打包时完全屏蔽
    showEnvironmentSwitcher() {
      return process.env.NODE_ENV === 'development';
    }
  }
};
</script>

<style>
body,
html,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: pingfang !important;
}

#app button,
#app .el-input__inner,
#app textarea {
  font-family: pingfang !important;
}

#atlas > div > div:nth-child(2) > div{
  display: none !important;
}
</style>
